export const CHUNK_SIZE = 16 // 16x16 tiles
export const TILE_SIZE = 16 // px
export const PIXEL_SIZE = 1 / TILE_SIZE // 1px = x world units

// ── render sorting ──
//
// World geometry now sorts primarily by z-depth.
//
// Y-sorted world geometry derives z from its bottom pivot y so static object
// tiles and dynamic sprites can interleave via depth. Fixed tile layers keep a
// constant z bias instead.
//
// renderOrder is still reserved for screen-space/debug overlays that should sit
// above the world regardless of depth.

// ── y-sorted world depth ──
export const WORLD_Z_PER_Y = 0.001
export const TILE_LAYER_Z_STEP = 0.0002

// ── tile layers ──
export const Layers = {
  TERRAIN: 0,
  DECOR: 1,
  OBJECT: 2,
  OVERLAY: 3,
}
export const LayerNames = {
  [Layers.TERRAIN]: 'terrain',
  [Layers.DECOR]: 'decor',
  [Layers.OBJECT]: 'objects',
  [Layers.OVERLAY]: 'overlay',
}

export const LayerOrders = {
  TERRAIN: -10,
  DECOR: -9,
  SHADOW: -5,
  OBJECT: 0,
  OVERLAY: 10,
  // NAMEPLATE: 900,
  COMBAT_TEXT: 901,
  COLLIDER: 902, // collider debug
  TARGETING: -4, // targeting shape (below objects, above shadows)
}

// avatar sub-quad layering (z-position offsets, not renderOrder)
export const ENTITY_Z_STEP = 0.00001
